const comparePrice = (productOptions, productVariant) => {
  let oneCover = ''
  let obj = {}
  let percentSavings = 0.25

  percentSavings = 1 - percentSavings

  if (productVariant.metafields && productVariant.metafields.length > 0) {
    productVariant.metafields.map((item) => {
      if (item.key === 'cover_size_variant') {
        oneCover = item.value
      }
    })
  }
  if (productOptions.length > 0) {
    productOptions.map((item) => {
      if (item.key === 'cover_size') {
        oneCover = item.value
      }
    })
  }
  let price = productVariant.price
  let comparePrice = (price / percentSavings).toFixed(2)
  let savingSqft = (comparePrice - price).toFixed(2)

  if (oneCover) {
    let priceSqft = (price / oneCover).toFixed(2)
    let comparePriceSqft = (priceSqft / percentSavings).toFixed(2)
    let savingSqft = (comparePriceSqft - priceSqft).toFixed(2)

    obj = {
      price: price,
      comparePrice: comparePrice,
      priceSqft: priceSqft,
      comparePriceSqft: comparePriceSqft,
      savingSqft: savingSqft,
      oneCover: oneCover,
    }
  } else {
    obj = {
      price: price,
      comparePrice: comparePrice,
      savingSqft: savingSqft,
    }
  }
  return obj
}

export default comparePrice
